import { PayeeTaxType } from '@willow/graphql-iso/src/app/backend';

import { assertNever } from './assertNever';

export const formatPayeeTaxType = (taxType: PayeeTaxType): string => {
  switch (taxType) {
    case PayeeTaxType.County:
      return 'County';
    case PayeeTaxType.City:
      return 'City';
    case PayeeTaxType.School:
      return 'School';
    case PayeeTaxType.Village:
      return 'Village';
    case PayeeTaxType.Town:
      return 'Town';
    case PayeeTaxType.Other:
      return 'Other';
    default:
      assertNever(taxType);
  }
};
